<template>
    <div>
        <div class="showcase-container">
            <div class="container">
                <slick-carousel class="showcase-carousel" :options="getPrimaryCarouselOptions()" ref="primaryCarousel">
                    <div v-for="(market, index) in markets" :key="'market-'+index" class="market">
                        <div class="container">
                            <div class="primary" :style="`background-image: url(${market.primary_image.url});`">
                                <h2 class="title" v-html="market.market_name"></h2>
                            </div>
                            <div class="secondary">
                                <div class="row top">
                                    <div class="full-col">
                                        <div class="inner">
                                            <div class="top-title" v-html="market.feature_1.top_title"></div>
                                            <h2 class="title" v-html="market.feature_1.title"></h2>
                                            <div class="copy" v-html="market.feature_1.copy"></div>
                                            <a v-if="market.feature_1.button" class="btn hover-button bright-blue" :href="market.feature_1.button.url" :target="market.feature_1.button.target" v-html="market.feature_1.button.title"></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <img class="secondary-image" :src="market.secondary_image['url']" />
                                    </div>
                                    <div class="col nex-col">
                                        <div class="next-block" @click="moveNext(index)">
                                            <div class="top-arrow"><i class="fas fa-chevron-right"></i></div>
                                            <div class="content">
                                                <div class="top-title">Next</div>
                                                <div class="next-market-title" v-html="nextMarket(index).market_name"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slick-carousel>
            </div>
            <div class="secondary-container bg-bright-blue">
                <div class="container">
                    <slick-carousel class="showcase-selection-carousel" :options="getSecondaryCarouselOptions()">
                        <div v-for="(market, index) in markets" class="item" :class="{active : selectedIndex == index}" :key="'market-selector-'+index" @click="setSelectedMarket(index)">
                            <div v-html="market.market_name"></div>
                            <div class="dot"></div>
                        </div>
                    </slick-carousel>
                </div>
            </div>
        </div>
        <div class="showcase-container-mobile">
            <div class="container">
                <slick-carousel class="showcase-carousel-mobile" :options="getMobileCarouselOptions()">
                    <div class="market" v-for="(market, index) in markets" :key="'mobile-market-'+index">
                        <div class="inner" :style="`background-image: url(${market.mobile_image.url});`">
                            <div class="top-title">Markets</div>
                            <h2 class="title" v-html="market.market_name"></h2>
                            <a class="btn btn-orange" :href="market.market_button.url" :target="market.market_button.target" v-html="market.market_button.title"></a>
                        </div>
                    </div>
                </slick-carousel>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
      block: {
          type: Object,
          required: true
      },
    },
    data() {
        return {
            selectedIndex: 0,
        }
    },
    mounted() {
    },
    computed: {
        markets : function() {
            return this.block.markets;
        },
        selectedMarket : function() {
            return this.markets[this.selectedIndex];
        },
        previousMarket : function() {
            var prevIndex = this.selectedIndex - 1;
            if (prevIndex < 0) {
                prevIndex = this.markets.length - 1;
            }
            return this.markets[prevIndex]
        }
    },
    methods: {
        getPrimaryCarouselOptions : function() {
            return {
                'slidesToShow': 1,
                'slidesToScroll': 1,
                'prevArrow': '<i class="slick-arrow top prev fas fa-chevron-left"></i>',
                'nextArrow': '<i class="slick-arrow top next fas fa-chevron-right"></i>',
                //'speed': 5000,
                'touchThreshold': 100,
                'infinite': false,
            }
        },
        getSecondaryCarouselOptions : function() {
            return {
                'slidesToShow': 6,
                'variableWidth': true,
                'arrows': false,
                'dots': false,
                'infinite': false,
                'responsive' : [
                    {
                        'breakpoint' : 1280,
                        'settings' : {
                            'slidesToShow' : 5,
                        }
                    },
                    {
                        'breakpoint' : 1000,
                        'settings' : {
                            'slidesToShow' : 4,
                        }
                    }
                ]
            }
        },
        getMobileCarouselOptions : function() {
            return {
                'slidesToShow': 2,
                'slidesToScroll': 1,
                'prevArrow': '<i class="slick-arrow top btn-blue prev fas fa-chevron-left"></i>',
                'nextArrow': '<i class="slick-arrow top btn-blue next fas fa-chevron-right"></i>',
                //'speed': 5000,
                'touchThreshold': 100,
                'infinite': false,
                'variableWidth': true,
                'responsive' : [
                    {
                        'breakpoint' : 695,
                        'settings' : {
                            'slidesToShow' : 1,
                        }
                    }
                ]
            }
        },
        setSelectedMarket: function(index) {
            this.$refs.primaryCarousel.goTo(index);
            this.selectedIndex = index;
        },
        nextIndex : function(index) {
            var nextIndex = index + 1;
            if (nextIndex >= this.markets.length) {
                nextIndex = 0;
            }
            return nextIndex;
        },
        moveNext: function(index) {
            this.setSelectedMarket(this.nextIndex(index));
        },
        nextMarket : function(index) {
            return this.markets[this.nextIndex(index)];
        },
    }
}
</script>